import { schema } from '@edgevanta/db/drizzle/client';
import { createInsertSchema, createSelectSchema } from 'drizzle-zod';
import { z } from 'zod/v4';
import { createQuerySchemaWithPagination } from '../shared';

export const selectBidSchema = createSelectSchema(schema.bids);

export const insertBidSchema = createInsertSchema(schema.bids, {
  rank: z.number().nullable(),
  winner: z.boolean(),
  timeAdjustment: z.string().nullable(),
  evaluationAdjustment: z.string().nullable(),
  adjustedTotal: z.string().nullable(),
  deviationPercent: z.string().nullable(),
  vendorId: z.string().uuid(),
});

export const updateBidSchema = insertBidSchema.partial().extend({
  id: z.string(),
});

const BidsQuerySchema = z.object({
  proposalId: z.string().uuid().optional(),
  'bid.rank': z.string().optional(),
  vendorId: z.string().uuid().optional(),
  'letting.date': z
    .string()
    .optional()
    .transform((val) => {
      if (!val) {
        return [];
      }
      return val.split(',').map((num) => Number(num));
    })
    .default([]),
  'bid.value': z
    .string()
    .optional()
    .transform((val) => {
      if (!val) {
        return [];
      }
      return val.split(',').map((num) => Number(num));
    })
    .default([]),
  'bid.deviation': z
    .string()
    .optional()
    .transform((val) => {
      if (!val) {
        return [];
      }
      return val.split(',').map((num) => Number(num));
    })
    .default([]),
  'bid.timeAdjustment': z
    .string()
    .optional()
    .transform((val) => {
      if (!val) {
        return [];
      }
      return val.split(',').map((num) => Number(num));
    })
    .default([]),
  'bid.evaluationAdjustment': z
    .string()
    .optional()
    .transform((val) => {
      if (!val) {
        return [];
      }
      return val.split(',').map((num) => Number(num));
    })
    .default([]),
  'bid.adjustedTotal': z
    .string()
    .optional()
    .transform((val) => {
      if (!val) {
        return [];
      }
      return val.split(',').map((num) => Number(num));
    })
    .default([]),
  'bid.deviationPercent': z
    .string()
    .optional()
    .transform((val) => {
      if (!val) {
        return [];
      }
      return val.split(',').map((num) => Number(num));
    })
    .default([]),
});

export const getBidsQuerySchema = createQuerySchemaWithPagination(
  BidsQuerySchema,
  { id: 'bid.rank', desc: true },
);

export const getBidsCountQuerySchema = BidsQuerySchema;
